<template>
  <div class="department-management">
    <div class="page-header">
      <h2>部门管理</h2>
      <el-button type="primary" @click="showCreateDialog">新增部门</el-button>
    </div>

    <!-- 搜索表单 -->
    <el-form :inline="true" :model="searchForm" class="search-form">
      <el-form-item label="部门名称">
        <el-input v-model="searchForm.department_name" placeholder="请输入部门名称" clearable />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
          <el-option label="禁用" :value="0" />
          <el-option label="启用" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="departmentList" border row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" style="width: 100%">
      <el-table-column prop="department_name" label="部门名称" width="200">
        <template slot-scope="scope">
          <span :style="{ paddingLeft: (scope.row.level * 20) + 'px' }">
            <i class="el-icon-office-building"></i>
            {{ scope.row.department_name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="department_code" label="部门编码" />
      <el-table-column prop="leader_name" label="部门负责人" />
      <el-table-column prop="leader_phone" label="负责人电话" />
      <el-table-column prop="user_count" label="人员数量" width="100">
        <template slot-scope="scope">
          <el-link type="primary" @click="viewDepartmentUsers(scope.row)">
            {{ scope.row.user_count || 0 }} 人
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="sort_order" label="排序" width="80" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180" />
      <el-table-column label="操作" width="270" fixed="right">
        <template slot-scope="scope">
          <div class="table-operations">
            <el-button size="mini" type="text" @click="viewDepartment(scope.row)">查看</el-button>
            <el-button size="mini" type="text" class="edit-btn" @click="editDepartment(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" class="success-btn" @click="addChildDepartment(scope.row)">添加子部门</el-button>
            <el-button size="mini" type="text" class="delete-btn" @click="deleteDepartment(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 部门表单对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form ref="departmentForm" :model="departmentForm" :rules="departmentRules" label-width="100px">
        <el-form-item label="上级部门" prop="parent_id">
          <el-cascader
            v-model="departmentForm.parent_id"
            :options="departmentOptions"
            :props="{ value: 'id', label: 'department_name', children: 'children', checkStrictly: true }"
            placeholder="请选择上级部门（不选择为顶级部门）"
            clearable
          />
        </el-form-item>
        <el-form-item label="部门名称" prop="department_name">
          <el-input v-model="departmentForm.department_name" />
        </el-form-item>
        <el-form-item label="部门编码" prop="department_code">
          <el-input v-model="departmentForm.department_code" />
        </el-form-item>
        <el-form-item label="部门负责人" prop="leader_name">
          <el-input v-model="departmentForm.leader_name" placeholder="请输入负责人姓名" />
        </el-form-item>
        <el-form-item label="负责人电话" prop="leader_phone">
          <el-input v-model="departmentForm.leader_phone" placeholder="请输入负责人电话" />
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input-number v-model="departmentForm.sort_order" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="departmentForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="departmentForm.remark" type="textarea" rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveDepartment">确定</el-button>
      </div>
    </el-dialog>

    <!-- 部门用户对话框 -->
    <el-dialog title="部门人员" :visible.sync="userDialogVisible" width="800px">
      <el-table :data="departmentUsers" border style="width: 100%">
        <el-table-column prop="username" label="用户名" />
        <el-table-column prop="real_name" label="真实姓名" />
        <el-table-column prop="email" label="邮箱" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDepartmentList, createDepartment, updateDepartment, deleteDepartment, getDepartmentUsers } from '../../api/system'

export default {
  name: 'DepartmentManagement',
  data() {
    return {
      loading: false,
      departmentList: [],
      departmentOptions: [],
      departmentUsers: [],
      searchForm: {
        department_name: '',
        status: ''
      },
      dialogVisible: false,
      dialogTitle: '新增部门',
      isEdit: false,
      departmentForm: {
        id: null,
        parent_id: null,
        department_name: '',
        department_code: '',
        leader_name: '',
        leader_phone: '',
        sort_order: 0,
        status: 1,
        remark: ''
      },
      departmentRules: {
        department_name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        department_code: [
          { required: true, message: '请输入部门编码', trigger: 'blur' }
        ],
        leader_phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ]
      },
      userDialogVisible: false
    }
  },
  created() {
    this.fetchDepartmentList()
  },
  methods: {
    async fetchDepartmentList() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm
        }
        const response = await getDepartmentList(params)
        if (response.code === 200) {
          this.departmentList = this.buildDepartmentTree(response.data.list)
          this.departmentOptions = [{ id: 0, department_name: '顶级部门', children: this.buildDepartmentOptions(response.data.list) }]
        }
      } catch (error) {
        this.$message.error('获取部门列表失败')
      } finally {
        this.loading = false
      }
    },
    buildDepartmentTree(data, level = 0) {
      return data.map(item => ({
        ...item,
        level: level,
        children: item.children ? this.buildDepartmentTree(item.children, level + 1) : []
      }))
    },
    buildDepartmentOptions(data) {
      return data.map(item => ({
        id: item.id,
        department_name: item.department_name,
        children: item.children ? this.buildDepartmentOptions(item.children) : []
      }))
    },
    handleSearch() {
      this.fetchDepartmentList()
    },
    handleReset() {
      this.searchForm = {
        department_name: '',
        status: ''
      }
      this.fetchDepartmentList()
    },
    showCreateDialog() {
      this.dialogTitle = '新增部门'
      this.isEdit = false
      this.departmentForm = {
        id: null,
        parent_id: null,
        department_name: '',
        department_code: '',
        leader_name: '',
        leader_phone: '',
        sort_order: 0,
        status: 1,
        remark: ''
      }
      this.dialogVisible = true
    },
    viewDepartment(row) {
      // 查看部门详情
      this.$message.info('查看功能待实现')
    },
    editDepartment(row) {
      this.dialogTitle = '编辑部门'
      this.isEdit = true
      this.departmentForm = { ...row }
      this.dialogVisible = true
    },
    addChildDepartment(row) {
      this.dialogTitle = '添加子部门'
      this.isEdit = false
      this.departmentForm = {
        id: null,
        parent_id: row.id,
        department_name: '',
        department_code: '',
        leader_name: '',
        leader_phone: '',
        sort_order: 0,
        status: 1,
        remark: ''
      }
      this.dialogVisible = true
    },
    async saveDepartment() {
      try {
        await this.$refs.departmentForm.validate()
        let response
        if (this.isEdit) {
          response = await updateDepartment(this.departmentForm)
        } else {
          response = await createDepartment(this.departmentForm)
        }
        
        if (response.code === 200) {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.dialogVisible = false
          this.fetchDepartmentList()
        } else {
          this.$message.error(response.msg || '操作失败')
        }
      } catch (error) {
        console.error('保存部门失败', error)
      }
    },
    async deleteDepartment(row) {
      // 检查是否有子部门
      if (row.children && row.children.length > 0) {
        this.$message.warning('该部门下存在子部门，请先删除子部门')
        return
      }
      
      // 检查是否有用户
      if (row.user_count > 0) {
        this.$message.warning('该部门下存在用户，请先转移用户')
        return
      }
      
      try {
        await this.$confirm('确定要删除该部门吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await deleteDepartment({ id: row.id })
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.fetchDepartmentList()
        } else {
          this.$message.error(response.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    async viewDepartmentUsers(row) {
      try {
        const response = await getDepartmentUsers({ department_id: row.id })
        if (response.code === 200) {
          this.departmentUsers = response.data
          this.userDialogVisible = true
        } else {
          this.$message.error(response.msg || '获取部门人员失败')
        }
      } catch (error) {
        this.$message.error('获取部门人员失败')
      }
    }
  }
}
</script>

<style scoped>
.department-management {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.table-operations {
  display: flex;
  gap: 4px;
  justify-content: center;
  flex-wrap: nowrap;
}

.table-operations .el-button--text {
  padding: 2px 6px;
  font-size: 12px;
  border: none;
  background: none;
  white-space: nowrap;
  min-width: unset;
}

.table-operations .edit-btn {
  color: #409eff;
}

.table-operations .edit-btn:hover {
  color: #66b1ff;
  background-color: #ecf5ff;
}

.table-operations .success-btn {
  color: #67c23a;
}

.table-operations .success-btn:hover {
  color: #85ce61;
  background-color: #f0f9eb;
}

.table-operations .delete-btn {
  color: #f56c6c;
}

.table-operations .delete-btn:hover {
  color: #f78989;
  background-color: #fef0f0;
}
</style>